import { useAppDispatch, useAppSelector } from 'src/store';
import { getCurrentProjectId } from 'src/app/projects/views/project-list/state/projectListSelector';
import useCustomer from 'src/app/customers/hooks/useCustomer';
import { showUpgradeModal } from 'src/global/state/site-menu/siteMenuSlice';
import { useEffect, useState } from 'react';
import useAppNavigation from './useAppNavigation';
import { FeatureType, Resources } from '../types';

export type HasResourceParams = {
    resource: Resources;
    projectId?: string;
};

export type HasFeatureParams = {
    feature: FeatureType;
    projectId?: string;
};

const useFeature = () => {
    const currentProjectId = useAppSelector(getCurrentProjectId);
    const { currentCustomerProjects, currentCustomerId } = useCustomer();
    const dispatch = useAppDispatch();
    const navigation = useAppNavigation();

    const [isFeatureAvailabilityCheckReady, setIsFeatureAvailabilityCheckReady] = useState(false);

    useEffect(() => {
        if (!currentCustomerId || currentCustomerProjects) {
            setIsFeatureAvailabilityCheckReady(true);
        }
    }, [currentCustomerId, currentCustomerProjects]);

    const hasResource = (params: HasResourceParams) => {
        const { projectId = currentProjectId, resource } = params;
        const currentProjectDetails = currentCustomerProjects?.find(project => project.projectId === projectId);
        const allowedResources = currentProjectDetails?.subscription?.allowedResources || [];
        return allowedResources.includes(resource);
    };

    const hasFeature = (params: HasFeatureParams) => {
        const { projectId = currentProjectId, feature } = params;
        const project = currentCustomerProjects?.find(project => project.projectId === projectId);
        return project?.features.includes(feature) || false;
    };

    const checkFeatureAvailabilityAndAlert = (params: HasResourceParams) => {
        if (!hasResource(params)) {
            dispatch(showUpgradeModal());
            return false;
        }
        return true;
    };

    const checkFeatureAvailabilityAndRedirect = (params: HasResourceParams) => {
        const { projectId = currentProjectId } = params;
        if (!hasResource(params) && projectId) {
            navigation.toUpgradeSubscription();
            return false;
        }

        return true;
    };

    return {
        isFeatureAvailabilityCheckReady,
        hasResource,
        hasFeature,
        checkFeatureAvailabilityAndAlert,
        checkFeatureAvailabilityAndRedirect,
    };
};

export default useFeature;
